import { Button } from 'antd';
import React from 'react';

import { useEmailReplyT } from './emailReplyStrings';
import styles from './OutboxStatus.module.css';
import type { OutboxItem } from './useEmailComposer';

interface Props {
  item: OutboxItem;
  onRetry: (localId: string) => void;
  onEdit: (localId: string) => void;
}

/** Where the time goes on a reply that is not saved yet: Sending…, Just now, or Couldn't send. */
const OutboxStatus: React.FC<Props> = ({ item, onRetry, onEdit }) => {
  const { t } = useEmailReplyT();

  if (item.status === 'failed') {
    return (
      <span
        role='alert'
        className={`${styles.status} ${styles.failed}`}
        title={item.error}
      >
        {t('couldntSend')}{' '}
        <Button
          type='link'
          size='small'
          style={{ fontSize: 12, padding: 0, height: 'auto' }}
          onClick={() => onRetry(item.localId)}
        >
          {t('retry')}
        </Button>{' '}
        <Button
          type='link'
          size='small'
          style={{ fontSize: 12, padding: 0, height: 'auto' }}
          onClick={() => onEdit(item.localId)}
        >
          {t('edit')}
        </Button>
      </span>
    );
  }
  return (
    <span className={styles.status}>
      {item.status === 'sending' ? t('sending') : t('justNow')}
    </span>
  );
};

export default OutboxStatus;
